<template>
  <div>
    <div class="e_home_head" :style="{ backgroundImage: 'url(' + img + ')' }">
      <!-- 左边 -->
      <div class="topleft animate__animated animate__backInLeft">
        <img src="@/assets/images/icon.png" />
        <div class="top_left_title">{{ cityName }}</div>
        <div class="top_left_title">{{ weatherlist.feelsLike }}℃-{{ weatherlist.temp }}℃</div>
        <div class="top_left_title">{{ weatherlist.text }}</div>
        <img src="@/assets/images/icon.png" />
      </div>
      <!--中间文字-->
      <div class="textcentre">中车低碳社区<img src="@/assets/images/head_i.png" />可视化数据</div>
    </div>
    <!--右边-->
    <div class="topright animate__animated animate__backInRight">
      <img src="@/assets/images/icon.png" />
      <div class="top_left_title">{{ nowDate }}</div>
      <div class="top_left_title">{{ nowtiem }}</div>
      <div class="top_left_title">{{ nowXing }}</div>
      <img src="@/assets/images/icon.png" />
    </div>
    <!-- 放大 -->
    <div class="full_g" @click="toggleFullScreen">
      <img :src="[isFullScreen == true ? fuImg : upImg]" alt="">
    </div>
  </div>
</template>

<script>
import getCurrentCityName from "../utils/getUserLocation";
import axios from "axios";
import 'animate.css';
export default {
  data() {
    return {
      img: require("../assets/images/top_bj.png"),
      weatherlist: "",
      nowDate: "",
      nowtiem: "",
      timer: null,
      cityName: "", //城市
      isFullScreen: false,
      nowXing: "",
      upImg: require("../assets/images/up.png"),
      fuImg: require("../assets/images/full.png"),
      //loaded: false // 标志变量，用于跟踪接口是否已加载
    };
  },
  props: {
    toptype: {
      //1 显示 根据头部显示隐藏部分传入类型2 3 4 5 6 7 进行判断
      type: Number,
    },
  },

  methods: {
    toggleFullScreen() {
      if (!this.isFullScreen) {
        this.enterFullScreen();
      } else {
        this.exitFullScreen();
      }
    },
    enterFullScreen() {
      const el = document.documentElement;
      if (el.requestFullscreen) {
        el.requestFullscreen().catch(err => {
          console.error(err);
        });
      } else if (el.mozRequestFullScreen) { /* Firefox */
        el.mozRequestFullScreen().catch(err => {
          console.error(err);
        });
      } else if (el.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        el.webkitRequestFullscreen().catch(err => {
          console.error(err);
        });
      } else if (el.msRequestFullscreen) { /* IE/Edge */
        el.msRequestFullscreen().catch(err => {
          console.error(err);
        });
      }
      this.isFullScreen = true;
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen().catch(err => {
          console.error(err);
        });
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen().catch(err => {
          console.error(err);
        });
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen().catch(err => {
          console.error(err);
        });
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen().catch(err => {
          console.error(err);
        });
      }
      this.isFullScreen = false;
    },
    returnfan() {
      this.$router.push({
        path: "/",
      });
    },
    //通过百度地图获取当前城市
    getCurrentCity() {
      getCurrentCityName().then((res) => {
        this.cityName = res.name;
        var cityArr = res.name.split("市");
        let location = cityArr[0];
        // 获取城市id
        axios({
          method: 'get',
          url: `https://geoapi.qweather.com/v2/city/lookup?location=${location}&key=f203064a79134114b47e5de604577389`,
        }).then(res => {
          if (res.data.code == 200) {
            this.cityCode = res.data.location[0]
            setTimeout(() => {
              this.serchWeather(this.cityCode.id);
            }, 200)
          }
        }).catch(err => {
          console.log(err, '失败')
        })

      });
    },
    // 实时天气
    serchWeather(data) {
      axios({
        method: 'get',
        url: `https://devapi.qweather.com/v7/weather/now?location=${data}&key=f203064a79134114b47e5de604577389`,
      }).then(res => {
        if (res.data.code == 200) {
          this.weatherlist = res.data.now
        } else {
          this.weatherlist = ''
        }
      }).catch(err => {

      })
    },
    //日期时间
    formatDate() {
      // if (!this.loaded) {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      let week = date.getDay(); // 星期
      let weekArr = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let weekArr1 = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];
      let hour = date.getHours(); // 时
      hour = hour < 10 ? "0" + hour : hour; // 如果只有一位，则前面补零
      let minute = date.getMinutes(); // 分
      minute = minute < 10 ? "0" + minute : minute; // 如果只有一位，则前面补零
      let second = date.getSeconds(); // 秒
      second = second < 10 ? "0" + second : second; // 如果只有一位，则前面补零

      this.nowDate = `${year}年${month}月${day}日`;
      this.nowtiem = `${hour}:${minute}:${second}`;
      this.nowXing = `${weekArr[week]}`;
      // this.loaded = true; // 设置标志变量为true，表示已加载
      // }
    },
    //定时器
    currentTime() {
      this.timer = setInterval(this.formatDate, 500);
    },
  },
  watch: {},
  mounted() {

    this.currentTime();
    this.getCurrentCity();
  },
  created() {
    // var getItem = JSON.parse(sessionStorage.getItem('title'))
    // let name = getItem
    // console.log(name)
    // this.name = name==null?"中国环保产业研究院-生态建设者联盟":name
  },
  // 销毁定时器
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
.e_home_head {
  width: 100%;
  height: 71px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 99;
  display: flex;
  justify-content: center;

  .textcentre {
    text-align: center;
    font-size: 36px;
    font-family: "maoken", sans-serif;
    line-height: 71px;
    color: #fff;

    img {
      width: 28px;
      height: 22px;
      margin: 0px 6px 0px 2px;
    }
  }
}

.topleft {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  left: 23px;
  line-height: 71px;
  align-items: center;

  img {
    width: 24px;
    height: 16px;
  }

  .top_left_title {
    font-family: "Source Han Sans CN";
    font-weight: bold;
    font-size: 16px;
    color: #34FFEA;
    margin: 0px 16px;
  }
}

.topright {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  right: 74px;
  height: 71px;
  align-items: center;
  top: 0px;

  img {
    width: 24px;
    height: 16px;
  }

  .top_left_title {
    font-family: "Source Han Sans CN";
    font-weight: bold;
    font-size: 16px;
    color: #34FFEA;
    margin: 0px 10px;
  }

}

.full_g {
  position: absolute;
  right: 26px;
  top: 18px;
  cursor: pointer;

  img {
    width: 28px;
    height: 29px;
  }


}
</style>